
import { defineComponent, ref, onMounted, computed } from 'vue';
import { storeToRefs } from 'pinia';
import router from '@/router';
import { useCouponTypesStore } from '@/store/useCouponTypes';

export default defineComponent({
  name: 'one-coupon-filter',
  setup(_, { emit }) {
    const routerId = ref(router.currentRoute.value.params.id);
    const couponTypesStore = useCouponTypesStore();
    const { allTypes } = storeToRefs(couponTypesStore);

    const types = computed(() => allTypes.value);

    const filterCoupons = async () => {
      // Wait until types are loaded; otherwise [] === [] would emit null and skip filtering.
      if (types.value.length === 0) {
        return;
      }
      if (selectedTypes.value.length === types.value.length) {
        // selectedTypes set to null to fetch all, including coupons without types
        emit('fetch', null);
      } else {
        // Emit couponTypeId array instead of code array
        emit('fetch', selectedTypes.value.map(Number));
      }
      saveToLocalStorage();
    };

    const selectedTypes = ref<number[]>([]);

    const saveToLocalStorage = () => {
      // save selected types to localStorage
      const stringified = JSON.stringify(selectedTypes.value);
      localStorage.setItem(`${routerId.value}-coupon-type-filter`, stringified);
    };

    onMounted(async () => {
      // Types load after app mount (see main.ts); must await before applying filter or
      // selectedTypes and types are both [] and we incorrectly emit fetch(null).
      await couponTypesStore.fetchCouponTypes();

      try {
        const raw = localStorage.getItem(`${routerId.value}-coupon-type-filter`);
        if (!raw) throw new Error('no saved filter');
        const parsedTypes = JSON.parse(raw) as unknown;
        if (!Array.isArray(parsedTypes) || parsedTypes.length === 0) {
          throw new Error('invalid saved filter');
        }
        const allowedIds = new Set(types.value.map((t) => t.id));
        const restored = parsedTypes
          .map(Number)
          .filter((id) => allowedIds.has(id));
        selectedTypes.value =
          restored.length > 0 ? restored : types.value.map((type) => type.id);
      } catch {
        selectedTypes.value = types.value.map((type) => type.id);
      }
      await filterCoupons();
    });

    return {
      selectedTypes,
      types,
      filterCoupons,
    };
  },
});
